module.exports = __webpack_public_path__ + "img/step3.dfcce5e7.png";